import React from 'react';

/**
 * Seta saindo de uma caixa, do botão "Saiba mais" dos cards com véu.
 *
 * Traçado (e não preenchimento) para acompanhar o peso do texto do botão;
 * decorativo, o nome acessível vem do `aria-label` do próprio link.
 */
export const ExternalLinkIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14 21 3" />
  </svg>
);

export default ExternalLinkIcon;
